















import { Vue, Component, Prop } from 'vue-property-decorator';
import CheckIcon from '../../icons/CheckIcon.vue';

@Component({
  components: {
    CheckIcon
  }
})
export default class Checkbox extends Vue {
  @Prop(Boolean) value!: boolean;
  @Prop(Boolean) disabled!: boolean;

  click() {
    if (!this.disabled) {
      this.$emit('change', !this.value);
    }
  }
}
